interface MobileMenuButtonProps {
  isOpen?: boolean;
  onClick: () => void;
}

export function MobileMenuButton({ isOpen = false, onClick }: MobileMenuButtonProps) {
  return (
    <div className="flex lg:hidden">
      <button
        type="button"
        className="relative inline-flex items-center justify-center rounded-md p-2 text-white hover:bg-darkdarkred focus:outline-none transition-colors duration-200 cursor-pointer h-12 w-12"
        onClick={onClick}
        aria-expanded={isOpen}
      >
        <span className="sr-only">{isOpen ? "Close main menu" : "Open main menu"}</span>
        
        {/* Animated Hamburger Icon using Pure CSS & Tailwind */}
        <div className="relative flex flex-col justify-between w-8 h-5.5">
          <span
            className={`block h-1 w-8 rounded-full bg-white transition-all duration-300 ease-in-out origin-center ${
              isOpen ? "rotate-45 translate-y-[9px]" : ""
            }`}
          />
          <span
            className={`block h-1 w-8 rounded-full bg-white transition-all duration-300 ease-in-out ${
              isOpen ? "opacity-0" : ""
            }`}
          />
          <span
            className={`block h-1 w-8 rounded-full bg-white transition-all duration-300 ease-in-out origin-center ${
              isOpen ? "-rotate-45 -translate-y-[9px]" : ""
            }`}
          />
        </div>
      </button>
    </div>
  );
}